import { Stack, TextField } from "@mui/material";
import { useFormikContext } from 'formik';


const Details = () => {
    const { values, handleChange } = useFormikContext<{ title: string; }>();

    return (
        <Stack gap={2} flex={1}>
            <TextField
                label="Título"
                fullWidth
                margin="normal"
                name="title"
                value={values.title}
                onChange={handleChange}
            />
        </Stack>
    );
}

export default Details;
